<template>
  <div :class="'popover-wrapper' + relative">
    <div :class="'tc-popover' + size" v-if="show">
      <div class="tc-popover-body">
        <slot></slot>
      </div>
      <div class="tc-popover-footer">
        <slot name="footer"></slot>
      </div>
    </div>
    <div class="tc-popover-blocked" v-if="show" @click="show = !show"></div>
  </div>
</template>

<script>
export default {
  props: ['toggle', 'isRelative', 'small'],
  watch: {
    toggle() {
      this.show = !this.show
    },
    show: {
      handler(show) {
        show ? this.$emit('open') : this.$emit('close')
      },
    },
  },
  data() {
    return {
      show: false,
    }
  },
  computed: {
    relative: function() {
      return this.isRelative ? ' popover-absolute' : ''
    },
    size: function() {
      return this.small ? ' popover-small' : ''
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';
@import '~bootstrap/scss/_functions';
@import '~bootstrap/scss/_variables';
@import '~bootstrap/scss/mixins/breakpoints';

.popover-absolute {
  position: relative !important;
}

.popover-wrapper {
  position: fixed;
  z-index: 1;
  // margin-top: 20px;
  margin-right: 20px;
}

.tc-popover-blocked {
  cursor: pointer;
  background-color: map-get($theme-colors, 'gray04');
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 1040;
  opacity: 0.3;
}

.user-popover {
  .tc-popover {
    // right: -200px;
    min-width: 400px;
  }
}

.popover-small {
  min-width: 285px !important;
  .tc-popover-body {
    min-height: 57vh !important;
  }
}

.tc-popover {
  &::after {
    top: 1px;
    border-bottom-color: map-get($theme-colors, 'white');
    border-width: 0 0.5rem 0.5rem 0.5rem;
  }

  position: absolute;
  z-index: 1050;
  background-color: map-get($theme-colors, 'white');
  border-radius: 6px;
  padding-top: 15px;
  right: 0;
  margin: 10px;
  display: flex;
  flex-direction: column;
  right: -30px;

  @media (max-width: 992px) {
    width: calc(100% - 50px);
    min-width: calc(100% - 50px);
    position: fixed;
    left: 15px;
  }

  .tc-popover-body {
    display: block;
    overflow: auto;
    margin: 1rem;
    max-height: 40vh;

    @include media-breakpoint-up(sm) {
      max-height: 67vh;
    }
  }

  .tc-popover-footer {
    width: 100%;
    height: 100%;
    display: table;
    background-color: map-get($theme-colors, 'denary');
  }
}
</style>
